<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper row" v-if="form">
      <div class="col-md-3 member">
        <p>ชื่อ</p>
        <h6>{{ userPresenter.name }}</h6>
        <p>E-mail</p>
        <h6>{{ userPresenter.email }}</h6>
        <p>เบอร์โทรศัพท์</p>
        <h6>{{ userPresenter.phone_number }}</h6>
      </div>
      <div class="col-md-4 info">
        <p>บ้านเลขที่</p>
        <h6>{{ homePresenter.address_number }}</h6>
        <p>โครงการ</p>
        <h6>{{ homePresenter.project.name }}</h6>
        <p>ประเภท</p>
        <h6>{{ homePresenter.type }}</h6>
        <p>พื้นที่ใช้สอย</p>
        <h6>{{ homePresenter.usable_area }} ตรม.</h6>
        <p>จำนวนชั้น</p>
        <h6>{{ homePresenter.floors }} ชั้น</h6>
        <p>จำนวนห้องนอน</p>
        <h6>{{ homePresenter.bedrooms }} ห้อง</h6>
        <p>จำนวนห้องน้ำ</p>
        <h6>{{ homePresenter.bathrooms }} ห้อง</h6>
        <p>ราคาฝากขาย</p>
        <h6>{{ homePresenter.sell_price | money }} บาท</h6>
        <p>ราคาปล่อยเช่า</p>
        <h6>{{ homePresenter.rent_price | money }} บาท</h6>
        <p>จุดประสงค์ของการฝากขายปล่อยเช่า</p>
        <h6 class="objective" v-for="item in objectivePresenter" :key="item">
          {{ item }}
        </h6>
        <p>ข้อมูลเพิ่มเติม</p>
        <h6>{{ notePresenter }}</h6>
      </div>
      <div class="col-md-4 info">
        <div class="update-status">
          <p>เปลี่ยนสถานะ</p>
          <sell-and-rent-status-select
            class="status-select"
            v-model="updatedStatus"
            :hide-item="handleHiddenItem"
            :disabled="isFormCancelled"
          ></sell-and-rent-status-select>
          <input
            name="feedback-remark"
            type="text"
            v-model="feedbackRemark"
            class="form-control feedback-remark"
            :disabled="isFormCancelled"
          />
          <div class="text-right">
            <sc-button
              class="status-button"
              variant="primary"
              @click="handleClickUpdateStatus"
              :disabled="isFormCancelled"
              >บันทึก</sc-button
            >
          </div>
        </div>
        <hr />
        <div>
          <p>Remark ล่าสุด: {{ feedbackRemarkText }}</p>
          <h6>{{ updatedTime | date }}</h6>
        </div>
        <div v-for="status in statusPresenter">
          <p>{{ status.label }}</p>
          <h6>{{ status.date | date }}</h6>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import Vue from "vue";
import { isNil } from "ramda";
import { DateTime } from "luxon";
import { Input as ElInput } from "element-ui";

import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { toLocaleTH } from "@/lib/dateTime";

import SellAndRentStatusSelect from "../components/SellAndRentStatusSelect";
import { SellAndRentStatus, SellAndRentStatusEnum } from "../SellAndRentStatus";

export default Vue.extend({
  components: {
    PageWrapper,
    ScButton,
    SellAndRentStatusSelect,
    ElInput
  },
  data() {
    const title = "รายละเอียดฝากขายปล่อยเช่า";
    const updatedStatus = null;
    const updatedTime = null;
    const feedbackRemark = null;
    const feedbackRemarkText = null;
    const feedbackAt = null;
    const form = null;
    return { title, updatedStatus, updatedTime, feedbackRemark, feedbackRemarkText, feedbackAt, form };
  },
  computed: {
    userPresenter() {
      const { user } = this.form;

      return user;
    },
    homePresenter() {
      const { home } = this.form;

      return home;
    },
    objectivePresenter() {
      const { objectives } = this.form;

      return objectives;
    },
    notePresenter() {
      const { note } = this.form;

      return note || "-";
    },
    statusPresenter() {
      const labels = {
        created_at: "อยู่ในระหว่างเจ้าหน้าที่ติดต่อกลับ",
        feedback_at: "ดำเนินการหาผู้ซื้อและ (หรือ) ผู้เช่า",
        approved_at: "ขาย หรือ ปล่อยเช่า เรียบร้อย",
        cancelled_at: "รายการถูกยกเลิก เนื่องจากลูกค้าแก้ไขข้อมูล"
      };

      return Object.keys(labels)
        .map(key => {
          let label = labels[key]
          if ((label === "อยู่ในระหว่างเจ้าหน้าที่ติดต่อกลับ") && this.form.is_resubmitted)
          {
            label += " (ลูกค้าแก้ไขข้อมูล)"
          }

          return { label, date: this.form[key] };
        })
        .filter(({ date }) => !!date);
    },
    currentStatus() {
      return this.form.status;
    },
    statusWeight() {
      return Object.keys(SellAndRentStatus).filter(
        status => status != SellAndRentStatusEnum.CANCELLED
      );
    },
    currentStatusText() {
      return SellAndRentStatus[this.currentStatus];
    },
    currentStatusCss() {
      return { completed: this.isCompleted };
    },
    isFormCancelled() {
      return this.currentStatus === SellAndRentStatusEnum.CANCELLED
    },
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();
    },
    async setupData() {
      await this.setupForm();
    },
    async setupForm() {
      const data = await this.fetchData();

      this.form = data.sell_and_rent_form;
      this.updatedStatus = this.form.status;
      this.feedbackRemarkText = this.form.feedback_remark;
      this.updatedTime = this.form.updated_at;
    },
    async fetchData() {
      const response = await baanRueJaiClient.admin.homes.sellAndRent.getForm(
        this.$route.params.id
      );

      return response.data.result;
    },
    async handleClickUpdateStatus() {
      if (this.currentStatus === this.updatedStatus && this.currentStatus === 'COMPLETED') {
        return;
      }

      const max = this.statusWeight.findIndex(s => s === this.updatedStatus);
      const min = this.statusWeight.findIndex(s => s === this.currentStatus);

      const map = {
        WAITING_FOR_AUTHORITY: "created_at",
        LOOKING_FOR_RENTERS: "feedback_at",
        COMPLETED: "approved_at",
        CANCELLED: "cancelled_at"
      };

      const keys = this.statusWeight
        .filter((_, w) => w > min && w <= max)
        .map(key => map[key]);

      if (!confirm("ยืนยันการเปลี่ยนสถานะ")) {
        return;
      }
      await this.updateStatus(keys);
      await this.setupData();
    },
    async updateStatus(statusList) {
      const { id } = this.$route.params;
      const now = DateTime.utc().toISO();
      const params = statusList.reduce(
        (all, status) => ({
          ...all,
          [status]: now,
        }),
        {}
      );
      params.feedback_remark = this.feedbackRemark;
      const response = await baanRueJaiClient.admin.homes.sellAndRent.put(
        id,
        params
      );
    },
    handleHiddenItem(status) {
      const current = this.statusWeight.findIndex(
        s => s === this.currentStatus
      );
      const target = this.statusWeight.findIndex(s => s === status);

      return target < current;
    }
  }
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

$break-small: 600px;
$break-large: 1000px;

.wrapper {
  padding: $space 0;
}

.member h6,
.info h6 {
  margin-bottom: 20px;
}

.info {
  @media screen and (max-width: $break-small) {
    padding-top: 20px;
    border-top: $border;
  }

  @media screen and (min-width: $break-large) {
    border-left: $border;
  }

  > .objective {
    margin-bottom: 10px;
  }
}

.update-status {
  margin-bottom: 1rem;

  > .status-select {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  > .feedback-remark {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

.current-status {
  &.completed {
    color: $success-color;
  }

  &.rejected {
    color: $danger-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/sell-and-rent/pages/SellAndRentDetailPage.vue